// extracted by mini-css-extract-plugin
export default {"coin":"Coin_coin__jNYcx","spin":"Coin_spin__SHwsj","coinSpin":"Coin_coinSpin__iqz9Y"};